import { render, staticRenderFns } from "./NewPoolDialog.vue?vue&type=template&id=3536b825&scoped=true"
import script from "./NewPoolDialog.vue?vue&type=script&lang=js"
export * from "./NewPoolDialog.vue?vue&type=script&lang=js"
import style0 from "./NewPoolDialog.vue?vue&type=style&index=0&id=3536b825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536b825",
  null
  
)

export default component.exports